import('./bootstrap');

export const dummy = 'to fix isolatedModules issue';